import request from '@/utils/request'

export function sendVerificationCode(data) {
  return request({
    url: 'guest/login',
    method: 'post',
    data
  })
}

export function loginByPhone(data) {
  return request({
    url: 'guest/login',
    method: 'post',
    data
  })
}

export function logout() {
  return request({
    url: 'guest/logout',
    method: 'post'
  })
}

export function getUserInfo() {
  return request({
    url: 'guest/user-info',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js